import { handleGetNftInfo } from '@/store/nft/epics/handleGetNftInfoEpic';

export const NftEpics = [handleGetNftInfo];
